import { css } from '@emotion/core';
import { Label, Paragraph4 } from '@nexus/lib-react/dist/core/Typography';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import styled from '../../../../../theme/styled';
import { mq } from '../../../../../commons/styles';

const ReturnsReportBlock = styled.div`
  display: flex;
  flex-direction: column;
  ${mq.mobileAndPhablet} {
    ${({ theme }) => css`
      margin: 0 ${theme.space[16]} 0 ${theme.space[16]};
      border-bottom: 1px solid ${theme.colors.grey3};
    `}
  }
  ${mq.desktop} {
    ${({ theme }) => css`
      padding: 0 0 ${theme.space[16]} 0;
    `}
`;

const ReturnsReportTitle = styled(Label)`
  font-style: normal;
  font-weight: 500;
`;

const ReturnsReportDataBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.space[4]};
`;

const ImageAndTextBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 95%;
`;

const ImageBlock = styled.div`
  position: relative;
  margin-right: ${({ theme }) => theme.space[16]};
  height: 60px;
  width: 60px;
`;

const AttachmentsCountText = styled.div`
  position: absolute;
  height: 15px;
  width: 15px;
  text-align: center;
  border-radius: 30px;
  ${({ theme }) => css`
    bottom: ${theme.space[4]};
    right: ${theme.space[4]};
    background-color: ${theme.colors.charcoal};
    color: ${theme.colors.white};
    font-size: ${theme.fontSizes[12]};
  `}
`;

const ReturnsReportText = styled(Paragraph4)`
  height: 54px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
  ${({ theme }) => css`
    color: ${theme.colors.secondary};
  `}
`;

const ArrowWrapper = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  height: 60px;
  width: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const ActionButton = styled(ButtonPrimaryDark)`
  padding: 6px 19px;
  width: auto;
  align-self: flex-end;
  ${({ theme }) => css`
    margin: ${theme.space[16]} 0;
    font-size: ${theme.fontSizes[14]};
  `};

  ${mq.desktop} {
    margin-bottom: 0;
  }
`;

export default {
  ReturnsReportBlock,
  ReturnsReportTitle,
  ReturnsReportDataBlock,
  ImageAndTextBlock,
  ImageBlock,
  AttachmentsCountText,
  ReturnsReportText,
  ArrowWrapper,
  ActionButton,
};
